import { writable, get as store_get } from "svelte/store";

/*
 * @property {Map} context
 * @property {Object|null} init_data
 */
export function store_init(context, init_data = null) {
  const cache = new Map();
  const stores = new Map();
  const waiting = new Map();

  for (const key in init_data) {
    cache.set(key, init_data[key]);
  }

  const out = {
    cache,
    async load(key, loader, ...params) {
      if (!cache.has(key)) {
        cache.set(key, await loader(context, ...params));
      }
      return cache.get(key);
    },
    writable(key, val, loader=null, ...params) {
      if (stores.has(key)) {
        return stores.get(key);
      }

      const out = writable(val, (set) => {
        if (cache.has(key)) {
          set(cache.get(key));
        } else {
          if (loader) {
            const tmp = loader(context, ...params).then((data) => {
              waiting.delete(key);

              set(data);
            }).catch(err => {
              waiting.delete(key);

              const errors = context.get("errors");
              errors.update(arr => {
                arr.push(err);
                return arr;
              });
            });

            waiting.set(key, tmp);
          }
        }
      });

      stores.set(key, out);

      return out;
    },
    readable(key, val, loader, ...params) {
      return {
        subscribe: out.writable(key, val, loader, ...params).subscribe
      };
    },
    async Poll() {
      for (const val of waiting.values()) {
        await val;
      }

      stores.forEach((val, key) => cache.set(key, store_get(val)));

      let out = {};

      cache.forEach((val, key) => out[key] = val);

      return out;
    }
  };

  return out;
}


